import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DepositPaymentPage from '../components/deposit-checkout/DepositPaymentPage';
import * as depositActions from '../redux/actions/depositActions';

const mapStateToProps = (state) => ({
  depositReducer: state.depositReducer,
});

const mapDispatchToProps = (dispatch) => ({
  depositActions: bindActionCreators(depositActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DepositPaymentPage);
